import { render, staticRenderFns } from "./EditTexture.vue?vue&type=template&id=c5420ebe&scoped=true"
import script from "./EditTexture.vue?vue&type=script&lang=js"
export * from "./EditTexture.vue?vue&type=script&lang=js"
import style0 from "./EditTexture.vue?vue&type=style&index=0&id=c5420ebe&prod&lang=scss"
import style1 from "./EditTexture.vue?vue&type=style&index=1&id=c5420ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5420ebe",
  null
  
)

export default component.exports